import React, { useState } from "react";

const Tabs = ({ defaultActiveKey, children }) => {
  const tabs = React.Children.toArray(children).filter(Boolean);
  const [activeKey, setActiveKey] = useState(
    defaultActiveKey || (tabs[0] && tabs[0].props.tabKey),
  );

  return (
    <div>
      <div className="tabs__nav">
        {tabs.map((tab) => (
          <button
            key={tab.props.tabKey}
            className={`tabs__tab${activeKey === tab.props.tabKey ? " tabs__tab--active" : ""}${tab.props.disabled ? " tabs__tab--disabled" : ""}`}
            onClick={() =>
              !tab.props.disabled && setActiveKey(tab.props.tabKey)
            }
          >
            {tab.props.tab}
          </button>
        ))}
      </div>
      <div className="tabs__content">
        {tabs.find((t) => t.props.tabKey === activeKey)?.props.children}
      </div>
    </div>
  );
};

export const TabPane = ({ children }) => <>{children}</>;

export default Tabs;
